import { render, staticRenderFns } from "./wrappedForm.vue?vue&type=template&id=17753b3b&scoped=true"
import script from "./wrappedForm.vue?vue&type=script&lang=js"
export * from "./wrappedForm.vue?vue&type=script&lang=js"
import style0 from "./wrappedForm.vue?vue&type=style&index=0&id=17753b3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17753b3b",
  null
  
)

export default component.exports